import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import { Row, Col, Panel, InputGroup } from 'react-bootstrap';
import TextInput from './TextInput';
import CheckBox from './CheckBox';
import { updateMyAccountUserAction } from '../../actions/userActions';

import {
    isEmptyObject,
    isEmptyString
} from '../../validators/formValidators';

import { normalizePhone } from '../../helpers/normalizers';
import { validatePhone } from './../../validators/formValidators';
import { caseSetServerError } from '../../actions/caseActions';
import { isDemoAccount } from './../../helpers/utils';

class TwoFactorAuth extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            Phone: '',
            PhoneError: '',
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loggedIn) {
            this.setState({
                Phone: nextProps.loggedIn['Phone'],
            });
        }
    }

    componentDidMount() {
        this.setState({
            Phone: this.props.loggedIn && this.props.loggedIn['Phone'],
        });
    }

    save(data) {
        this.props.dispatch(updateMyAccountUserAction(data))
            .then(result => {
                this.setState({ loading: false });
            })
            .catch(error => {
                this.setState({ loading: false });
                this.props.dispatch(caseSetServerError(error));
                console.error(new Error().stack, error);
            });
    }

    render() {
        const {
            loggedIn,
            style,
        } = this.props;

        let loading = this.state.loading;
        return (
            <Panel data-hj-whitelist header='Security' style={{ marginTop: 15, ...style }}>
                <Row>
                    <Col xs={12}>
                        <TextInput label="Mobile Phone"
                            field={{
                                name: 'Phone',
                                onChange: (evt) => {
                                    let Phone = normalizePhone(evt.target.value, this.state.Phone);
                                    let error = validatePhone(Phone, 'PhoneError');
                                    if (!isEmptyObject(error)) {
                                        this.setState({PhoneError: error['PhoneError'], Phone});

                                    } else{
                                        this.setState({PhoneError: '', Phone});
                                    }
                                },
                                value: this.state.Phone,
                                touched: true,
                                error: this.state.PhoneError,
                            }}
                            disabled={loggedIn['TwoFactorAuth'] || loading || isDemoAccount(loggedIn)}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <CheckBox field={{
                                      name: 'TwoFactor',
                                  }}
                                  checked={loggedIn['TwoFactorAuth']}
                                  onChange={() => {
                                    this.setState({loading: true});
                                    this.props.dispatch(updateMyAccountUserAction({
                                            ...loggedIn,
                                            'TwoFactorAuth': !loggedIn['TwoFactorAuth'],
                                            'Phone': this.state.Phone,
                                        }))
                                        .then(result => {
                                            this.setState({loading: false});
                                        })
                                        .catch(error => {
                                            this.setState({loading: false});
                                            this.props.dispatch(caseSetServerError(error));
                                            console.error(new Error().stack, error);
                                        });
                                  }}
                                  loading={loading}
                                  disabled={isEmptyString(this.state.Phone) ||
                                            loading ||
                                            !isEmptyObject(validatePhone(this.state.Phone)) ||
                                            isDemoAccount(loggedIn)}
                                  label="Enable 2 Factor Authentication" />
                    </Col>
                </Row>
            </Panel>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let loggedIn = state.user.loggedIn;
    return {
        loggedIn
    };
};

export default connect(mapStateToProps)(TwoFactorAuth);

